/**
 * Authenticated document opener.
 * The API only accepts a Bearer header, so a plain <a href> download returns
 * {"detail":"Invalid token"}. Fetch it with the header and hand the browser a
 * blob instead — opens in a tab for html/pdf, downloads for Word.
 */
import axios from "axios";
import { toast } from "sonner";
import { API } from "@/App";

export async function openAuthedDoc(path, { token, fmt = "pdf", filename, params = {} } = {}) {
  try {
    const r = await axios.get(`${API}${path}`, {
      params: { fmt, ...params },
      headers: { Authorization: `Bearer ${token}` },
      responseType: "blob",
    });
    const url = URL.createObjectURL(r.data);
    if (fmt === "docx" || filename) {
      const a = document.createElement("a");
      a.href = url;
      a.download = filename || "document";
      a.click();
    } else {
      window.open(url, "_blank", "noopener");
    }
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch (e) {
    let detail = e?.response?.data?.detail;
    if (e?.response?.data instanceof Blob) {
      try { detail = JSON.parse(await e.response.data.text()).detail; } catch { /* keep */ }
    }
    toast.error(detail || "Could not build that document");
  }
}
